import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, from } from 'rxjs';
import { map, catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { GeoService } from '../../geo.service';
import * as GeoActions from '../action/geo.action';
import { selectGeoState } from '../selector/geo.selector';

@Injectable()
export class GeoEffects {

  checkGeoLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GeoActions.checkGeoLocation),
      withLatestFrom(this.store.select(selectGeoState)),
      switchMap(([action, geoState]) => {
        // Check if we have valid cached data
        const now = Date.now();
        const isExpired = !geoState.lastChecked || 
          (now - geoState.lastChecked) > geoState.cacheExpiry;

        if (!isExpired && geoState.isRegulated !== null) {
          // Return empty action since data is already in store
          return of({ type: '[Geo] Cache Used' } as any);
        }
        return from(this.geoService.isRegulatedRegion()).pipe(
          map((isRegulated: boolean) => GeoActions.geoLocationSuccess({ 
            isRegulated, 
            country: 'unknown' // You can enhance this to get actual country
          })),
          catchError(error => of(GeoActions.geoLocationFailure({ error })))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private geoService: GeoService
  ) {}
}